import httpRequest from '../request/indexBase'
import { fetchEventSource } from '@microsoft/fetch-event-source'
import permissionHeader from '@/utils/permissionHeader'
import { local } from '@/utils/storage'
const perModuleType = '0'

// OBS获取AK,SK,ST
export function queryObsAKSKST() {
  return httpRequest.get({
    url: `/video/obsToken/queryObsAKSKST`
  })
}

// 知识库导入
export function databaseImport(data) {
  return httpRequest.post({
    url: `/video/video-edit-record/weaviateSaveVideoRecord`,
    data
  })
}

// 链接导入
export function linkImport(data) {
  return httpRequest.post({
    url: `/repository/files-record/fileUploadObs`,
    data
  })
}

// 本地导入
export function localImport(data) {
  return httpRequest.post({
    url: `/video/video-edit-record`,
    data
  })
}

// 查询待处理个数
export function getCount(params) {
  return httpRequest.get({
    url: `/video/video-edit-record/getVideoUnreadCount`,
    params
  })
}

// 查询链接导入列表
export function getList(data) {
  return httpRequest.post({
    url: `/repository/files-record/getUploadProgress`,
    data
  })
}

// 取消链接导入任务
export function cancelLinkTask(params) {
  return httpRequest.get({
    url: `/repository/files-record/cancelFileUp/${params.id}`
  })
}

// 查询视频详情
export function getVideoInfo(params) {
  return httpRequest.get({
    url: `/video/video-edit-record/${params.id}`
  })
}

// 查询详情总结列表
export function getSummaryList(params) {
  return httpRequest.get({
    url: `/video/video-chapter-summary/getChapterSummaryListByRecordId`,
    params
  })
}

// 查询最近总结列表
export function getLatestSummaryList(params) {
  return httpRequest.get({
    url: `/video/video-edit-record/getVideoEditRecordTopTen`,
    params
  })
}

// 查询推荐提问
export function getRecommendList(data) {
  return httpRequest.post({
    url: `/video/video-potential-question/getUserPotentialQuestionList`,
    data
  })
}
//创建聊天
export function createChatInfo(data) {
  return httpRequest.post({
    url: `/video/aicut-chat-title/createChatTitle`,
    data
  })
}
//查询聊天
export function getChatInfo(params) {
  return httpRequest.get({
    url: `/video/aicut-chat-title/queryAiCutChatTitleList/${params.videoRecordId}`
  })
}
//查询聊天记录
export function getRecord(params) {
  return httpRequest.get({
    url: `/video/aicut-chat-record/queryAiCutChatRecord/${params.aiCutChatTitleId}`
  })
}
// 修改聊天实体信息
export function updateChatInfo(data) {
  return httpRequest.put({
    url: `/video/aicut-chat-title`,
    data
  })
}
// 发送会话
export function sendChat(data, onopen, onmessage, onclose, onerror, ctrl) {
  return fetchEventSource(
    process.env.VUE_APP_API_URL + '/video/aicut-chat-record/aiCutChatCompletion',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/event-stream',
        token: local.get('TOKEN'),
        ...permissionHeader()
      },
      body: JSON.stringify(data),
      signal: ctrl.signal,
      openWhenHidden: true,
      onopen(response) {
        // 开启流
        console.log('onopen')
        onopen && onopen(response)
      },
      onmessage(event) {
        // 监听流
        onmessage && onmessage(event)
      },
      onclose(e) {
        // 关闭流
        onclose && onclose(e)
      },
      onerror: (e) => {
        //返回流报错
        onerror && onerror(e)
        throw e
      }
    }
  )
}

//根据视频记录ID查询结果状态
export function getVideoTaskDetailsStatus(params) {
  return httpRequest.get({
    url: `/video/video-edit-record/getVideoTaskDetailsStatus`,
    params
  })
}

//根据视频记录ID查询视频章节信息列表
export function getChapterSummaryPageVoListByRecordId(params) {
  return httpRequest.get({
    url: `/video/video-chapter-summary/getChapterSummaryPageVoListByRecordId`,
    params
  })
}

//根据视频记录ID查询视频摘要总结
export function getAbstractSummaryByVideoRecordId(params) {
  return httpRequest.get({
    url: `/video/video-abstract-summary/getAbstractSummaryByVideoRecordId`,
    params
  })
}

//根据视频记录ID查询视频总结标签
export function getSummaryTagsByVideoRecordId(params) {
  return httpRequest.get({
    url: `/video/video-summary-tags/getSummaryTagsByVideoRecordId`,
    params
  })
}

//根据视频记录ID查询视频总结亮点
export function getSummaryHighlightVoListByVideoRecordId(params) {
  return httpRequest.get({
    url: `/video/video-summary-highlights/getSummaryHighlightVoListByVideoRecordId`,
    params
  })
}

// 下载片段
export function downloadSubtitle(data) {
  return httpRequest.put({
    url: `/video/video-download-center/downVideoAndCaptions`,
    data
  })
}

// 导出总结
export function exportFileTypeVideoSummary(data) {
  return httpRequest.post({
    url: `/video/video-abstract-summary/ExportSummary`,
    data,
    responseType: 'blob'
  })
}

// 保存总结到知识库
export function saveFileTypeVideoSummary(data, perFolderId = '') {
  return httpRequest.post({
    url: `/video/video-abstract-summary/saveSummaryToWeAviate`,
    data,
    params: {
      perFolderId,
      perModuleType
    }
  })
}

// 导出字幕
export function exportFileTypeVideoSubtitles(data) {
  return httpRequest.post({
    url: `/video/video-subtitles-info/exportFileTypeVideoSubtitles`,
    data,
    responseType: 'blob'
  })
}

// 导出人物
export function exportFileTypeVideoCharacters(data) {
  return httpRequest.post({
    url: `/video/video-subtitles-character-image/exportSubtitlesCharacter`,
    data,
    responseType: 'blob'
  })
}

// 翻译状态查询
export function queryTranStatus(data) {
  return httpRequest.get({
    url: `/video/translation-settings/queryTranStatus/${data.videoRecordId}`,
    data
  })
}

// 查询字幕是否存在和翻译结果
export function queryTranSubtitlesExist(data) {
  return httpRequest.get({
    url: `/video/translation-settings/queryTranSubtitlesExist/${data.videoRecordId}`,
    data
  })
}

// 翻译字幕
export function videoTranslation(data) {
  return httpRequest.post({
    url: `/video/translation-settings/videoTranslation`,
    data
  })
}

// 替换字幕
export function replaceVideoSubtitles(data) {
  return httpRequest.put({
    url: `/video/video-subtitles-info/replaceVideoSubtitles`,
    data
  })
}

// 批量修改字幕
export function updateBatchVideoSubtitlesInfo(data) {
  return httpRequest.put({
    url: `/video/video-subtitles-info/updateBatchVideoSubtitlesInfo`,
    data
  })
}
// 修改视频字幕说话人
export function updateSpeaker(data) {
  return httpRequest.put({
    url: `/video/video-subtitles-speaker-info`,
    data
  })
}

// 查询视频人物信息列表
export function getCharacterInfoByVideoId(params) {
  return httpRequest.get({
    url: `/video/video-subtitles-character-info/getCharacterInfoByVideoId`,
    params
  })
}

// 修改视频人物信息
export function updateCharacterInfo(data) {
  return httpRequest.put({
    url: `/video/video-subtitles-character-info`,
    data
  })
}
